export const REQUEST_SHIPMENTS = 'REQUEST_SHIPMENTS';
export const REQUEST_SHIPMENTS_SUCCESS = 'REQUEST_SHIPMENTS_SUCCESS';
export const REQUEST_SHIPMENTS_FAILURE = 'REQUEST_SHIPMENTS_FAILURE';

export const REQUEST_SHIPMENT = 'REQUEST_SHIPMENT';
export const REQUEST_SHIPMENT_SUCCESS = 'REQUEST_SHIPMENT_SUCCESS';
export const REQUEST_SHIPMENT_FAILURE = 'REQUEST_SHIPMENT_FAILURE';

export const REQUEST_SHIPMENTS_PROBLEM = 'REQUEST_SHIPMENTS_PROBLEM';
export const REQUEST_SHIPMENTS_PROBLEM_SUCCESS = 'REQUEST_SHIPMENTS_PROBLEM_SUCCESS';
export const REQUEST_SHIPMENTS_PROBLEM_FAILURE = 'REQUEST_SHIPMENTS_PROBLEM_FAILURE';

export const REQUEST_SHIPMENT_PROBLEM = 'REQUEST_SHIPMENT_PROBLEM';
export const REQUEST_SHIPMENT_PROBLEM_SUCCESS = 'REQUEST_SHIPMENT_PROBLEM_SUCCESS';
export const REQUEST_SHIPMENT_PROBLEM_FAILURE = 'REQUEST_SHIPMENT_PROBLEM_FAILURE';

export const REQUEST_ARRIVALS_PROBLEM = 'REQUEST_ARRIVALS_PROBLEM';
export const REQUEST_ARRIVALS_PROBLEM_SUCCESS = 'REQUEST_ARRIVALS_PROBLEM_SUCCESS';
export const REQUEST_ARRIVALS_PROBLEM_FAILURE = 'REQUEST_ARRIVALS_PROBLEM_FAILURE';

export const REQUEST_ARRIVAL_PROBLEM = 'REQUEST_ARRIVAL_PROBLEM';
export const REQUEST_ARRIVAL_PROBLEM_SUCCESS = 'REQUEST_ARRIVAL_PROBLEM_SUCCESS';
export const REQUEST_ARRIVAL_PROBLEM_FAILURE = 'REQUEST_ARRIVAL_PROBLEM_FAILURE';

export const REQUEST_SHIPMENTS_PLAT_NUMBER = 'REQUEST_SHIPMENTS_PLAT_NUMBER';
export const REQUEST_SHIPMENTS_PLAT_NUMBER_SUCCESS = 'REQUEST_SHIPMENTS_PLAT_NUMBER_SUCCESS';
export const REQUEST_SHIPMENTS_PLAT_NUMBER_FAILURE = 'REQUEST_SHIPMENTS_PLAT_NUMBER_FAILURE';

export const REQUEST_SHIPMENTS_ORDER_NUMBER = 'REQUEST_SHIPMENTS_ORDER_NUMBER';
export const REQUEST_SHIPMENTS_ORDER_NUMBER_SUCCESS = 'REQUEST_SHIPMENTS_ORDER_NUMBER_SUCCESS';
export const REQUEST_SHIPMENTS_ORDER_NUMBER_FAILURE = 'REQUEST_SHIPMENTS_ORDER_NUMBER_FAILURE';

export const REQUEST_PRINT_PACKING_LIST = 'REQUEST_PRINT_PACKING_LIST';
export const REQUEST_PRINT_PACKING_LIST_SUCCESS = 'REQUEST_PRINT_PACKING_LIST_SUCCESS';
export const REQUEST_PRINT_PACKING_LIST_FAILURE = 'REQUEST_PRINT_PACKING_LIST_FAILURE';

export const REQUEST_PRINT_DO = 'REQUEST_PRINT_DO';
export const REQUEST_PRINT_DO_SUCCESS = 'REQUEST_PRINT_DO_SUCCESS';
export const REQUEST_PRINT_DO_FAILURE = 'REQUEST_PRINT_DO_FAILURE';

export const REQUEST_SHIPMENTS_PROBLEM_PRINT = 'REQUEST_SHIPMENTS_PROBLEM_PRINT';
export const REQUEST_SHIPMENTS_PROBLEM_PRINT_SUCCESS = 'REQUEST_SHIPMENTS_PROBLEM_PRINT_SUCCESS';
export const REQUEST_SHIPMENTS_PROBLEM_PRINT_FAILURE = 'REQUEST_SHIPMENTS_PROBLEM_PRINT_FAILURE';

export const REQUEST_ARRIVALS_PROBLEM_PRINT = 'REQUEST_ARRIVALS_PROBLEM_PRINT';
export const REQUEST_ARRIVALS_PROBLEM_PRINT_SUCCESS = 'REQUEST_ARRIVALS_PROBLEM_PRINT_SUCCESS';
export const REQUEST_ARRIVALS_PROBLEM_PRINT_FAILURE = 'REQUEST_ARRIVALS_PROBLEM_PRINT_FAILURE';

export const REQUEST_SHIPMENTS_PRINT = 'REQUEST_SHIPMENTS_PRINT';
export const REQUEST_SHIPMENTS_PRINT_FAILURE = 'REQUEST_SHIPMENTS_PRINT_FAILURE';
export const REQUEST_SHIPMENTS_PRINT_SUCCESS = 'REQUEST_SHIPMENTS_PRINT_SUCCESS';

export const REQUEST_RELEASE_ITEM_PROBLEM = 'REQUEST_RELEASE_ITEM_PROBLEM';
export const REQUEST_RELEASE_ITEM_PROBLEM_FAILURE = 'REQUEST_RELEASE_ITEM_PROBLEM_FAILURE';
export const REQUEST_RELEASE_ITEM_PROBLEM_SUCCESS = 'REQUEST_RELEASE_ITEM_PROBLEM_SUCCESS';

export const REQUEST_LOST_ITEM_PROBLEM = 'REQUEST_LOST_ITEM_PROBLEM';
export const REQUEST_LOST_ITEM_PROBLEM_FAILURE = 'REQUEST_LOST_ITEM_PROBLEM_FAILURE';
export const REQUEST_LOST_ITEM_PROBLEM_SUCCESS = 'REQUEST_LOST_ITEM_PROBLEM_SUCCESS';

export const REQUEST_RELEASE_ARRIVAL_PROBLEM = 'REQUEST_RELEASE_ARRIVAL_PROBLEM';
export const REQUEST_RELEASE_ARRIVAL_PROBLEM_FAILURE = 'REQUEST_RELEASE_ARRIVAL_PROBLEM_FAILURE';
export const REQUEST_RELEASE_ARRIVAL_PROBLEM_SUCCESS = 'REQUEST_RELEASE_ARRIVAL_PROBLEM_SUCCESS';

export const REQUEST_LOST_ARRIVAL_PROBLEM = 'REQUEST_LOST_ARRIVAL_PROBLEM';
export const REQUEST_LOST_ARRIVAL_PROBLEM_FAILURE = 'REQUEST_LOST_ARRIVAL_PROBLEM_FAILURE';
export const REQUEST_LOST_ARRIVAL_PROBLEM_SUCCESS = 'REQUEST_LOST_ARRIVAL_PROBLEM_SUCCESS';

export const REQUEST_LOST_SOLVED_PROBLEM = 'REQUEST_LOST_SOLVED_PROBLEM';
export const REQUEST_LOST_SOLVED_PROBLEM_FAILURE = 'REQUEST_LOST_SOLVED_PROBLEM_FAILURE';
export const REQUEST_LOST_SOLVED_PROBLEM_SUCCESS = 'REQUEST_LOST_SOLVED_PROBLEM_SUCCESS';

export const REQUEST_VEHICLES_AVAILABLE = 'REQUEST_VEHICLES_AVAILABLE';
export const REQUEST_VEHICLES_AVAILABLE_FAILURE = 'REQUEST_VEHICLES_AVAILABLE_FAILURE';
export const REQUEST_VEHICLES_AVAILABLE_SUCCESS = 'REQUEST_VEHICLES_AVAILABLE_SUCCESS';

export const REQUEST_SERVICES_ROUTE = 'REQUEST_SERVICES_ROUTE';
export const REQUEST_SERVICES_ROUTE_FAILURE = 'REQUEST_SERVICES_ROUTE_FAILURE';
export const REQUEST_SERVICES_ROUTE_SUCCESS = 'REQUEST_SERVICES_ROUTE_SUCCESS';

export const REQUEST_VEHICLE_AVAILABLE = 'REQUEST_VEHICLE_AVAILABLE';
export const REQUEST_VEHICLE_AVAILABLE_FAILURE = 'REQUEST_VEHICLE_AVAILABLE_FAILURE';
export const REQUEST_VEHICLE_AVAILABLE_SUCCESS = 'REQUEST_VEHICLE_AVAILABLE_SUCCESS';

export const REQUEST_SERVICE_ROUTE = 'REQUEST_SERVICE_ROUTE';
export const REQUEST_SERVICE_ROUTE_FAILURE = 'REQUEST_SERVICE_ROUTE_FAILURE';
export const REQUEST_SERVICE_ROUTE_SUCCESS = 'REQUEST_SERVICE_ROUTE_SUCCESS';

export const REQUEST_SHIPMENT_READY_PRINT = 'REQUEST_SHIPMENT_READY_PRINT';
export const REQUEST_SHIPMENT_READY_PRINT_FAILURE = 'REQUEST_SHIPMENT_READY_PRINT_FAILURE';
export const REQUEST_SHIPMENT_READY_PRINT_SUCCESS = 'REQUEST_SHIPMENT_READY_PRINT_SUCCESS';



